<template>
    <section id="page-dagen-kiezen" class="page-dagen-kiezen page">
        <div class="page__content container">
            <div class="page__icon-wrapper"><i class="fa fa-calendar" aria-hidden="true"></i></div>
            <h1>ALS HYBRIDE DOCENT ZUL JE KEUZES MOETEN MAKEN OVER DE INDELING VAN JE WERKWEEK</h1>
            <p>Hoeveel dagen wil je in beide banen werken?</p>

            <div class="days-select">
                <div class="days-select__title">1. Huidige baan</div>
                <div class="days-select__job">{{getJobDescrption(userProfile.baan1)}}</div>
                <div class="days-select__day" v-for="nmb in nmbDays" v-on:click="selectType(0, nmb)"
                    v-bind:class="daysClass(0, nmb)">{{nmb}}</div>
            </div>

            <div class="days-select">
                <div class="days-select__title">2. Nieuwe baan</div>
                <div class="days-select__job">{{getJobDescrption(userProfile.baan2)}}</div>
                <div class="days-select__day" v-for="nmb in nmbDays" v-on:click="selectType(1, nmb)"
                    v-bind:class="daysClass(1, nmb)">{{nmb}}</div>
            </div>

            <p><button class="button" v-on:click="submitDays()">Volgende</button></p>

            <p v-if="!validCombination && daysSubmitted" class="error-panel">
                Kies voor elke baan minstens 1 dag in de week
            </p>
            <div class="result-anchor"></div>
            <div class="result-box" v-if="validCombination && daysSubmitted">
                <p>{{result}}</p>
                <page-next-button v-on:click="nextHandler"></page-next-button>
            </div>
        </div>
    </section>
</template>
<style lang="stylus">
    .page-dagen-kiezen .days-select
        margin 30px 0

    .result-box
        margin-top 30px
        padding-top 15px
        border-top 1px solid

</style>
<script>
    import page from './page';

    export default {
        mixins: [page],
        data() {
            return {
                nmbDays: [1, 2, 3, 4, 5],
                jobDays: [-1, -1],
                generiek: 'Meestal staan hybride docenten twee à drie dagen voor de klas. Met deze verdeling haal je het beste uit jezelf en jouw twee werkomgevingen. Ook een andere verdeling is natuurlijk mogelijk, maar het is wel zo dat hybride docenten aangeven dat het dan moeilijker is om de meerwaarde van het combineren van banen te benutten.',
                commentsEenBaanDocent: [
                    'Je geeft aan 1 dag per week als leraar te willen werken. Dat vinden we natuurlijk super leuk! Het is wel zo dat hybride docenten aangeven dat dit vaak net te weinig is om het beste uit jezelf en je twee werkomgevingen te halen. Meestal staan hybride docenten twee à drie dagen per week voor de klas. Ook zien we dat er niet veel vacatures zijn voor mensen die één dag in de week als leraar willen werken. Maar... het kan natuurlijk wel. Het ligt maar net de mogelijkheden op de school waar jij wil werken.',
                    'Je geeft aan 2 dagen als leraar te willen werken. Dat vinden we super leuk! Meestal staan hybride docenten twee of drie dagen voor de klas, dus jouw keuze kan heel goed werken. Met twee of drie dagen haal je het beste uit jezelf en twee werkomgevingen.',
                    'Je geeft aan 3 dagen als leraar te willen werken. Dat vinden we super leuk! Meestal staan hybride docenten twee of drie dagen voor de klas, dus jouw keuze kan heel goed werken. Met twee of drie dagen haal je het beste uit jezelf en twee werkomgevingen.',
                    'Je geeft aan 4 dagen als leraar te willen werken. Dat vinden we super leuk! Met vier dagen in de week ben je bijna fulltime docent. Het kan in de praktijk lastig zijn om daarnaast een vacature voor één dag te vinden. Maar... het kan natuurlijk wel. Het ligt maar net de mogelijkheden bij de werkgever waar jij wil werken.'
                ],
                /* commentsTweeBanenDocent: [
                    'Je kiest ervoor om één dag les te geven in je huidige baan en [aantal] [dagen] in een tweede baan. Dat vinden we super leuk! In de praktijk zien we wel dat er minder vacatures zijn voor vakken met één werkdag. Ook ervaren hybride docenten het vaak zelf als net te weinig om het beste uit jezelf en je twee lesomgevingen te halen. Meestal combineren hybride docenten het lesgeven met twee om drie dagen per week per vak. Maar...één om vier dagen dag kan natuurlijk wel. Het ligt maar net aan de mogelijkheden op de school waar jij wil werken.',
                    'Je kiest ervoor om twee dagen les te geven in je huidige baan en [aantal] [dagen] in een tweede baan. Dat vinden is perfect! Meestal combineren hybride docenten het lesgeven met twee om drie dagen per week per vak, dus jouw keuze kan heel goed. Met twee of drie dagen haal je het beste uit jezelf en twee lesomgevingen.',
                    'Je kiest ervoor om drie dagen les te geven in je huidige baan en [aantal] [dagen] in een tweede baan. Dat is perfect! Meestal combineren hybride docenten het lesgeven met twee om drie dagen per week per vak, dus jouw keuze kan heel goed. Met twee of drie dagen haal je het beste uit jezelf en twee lesomgevingen.',
                    'Je kiest ervoor om vier dagen les te geven in je huidige baan en [aantal] [dagen] in een tweede baan. HIER ONTBREEKT NOG TEKST!!!'
                ], */
                daysSubmitted: false
            }
        },
        computed: {
            validCombination() {
                return this._validCombination();
            },
            result() {
                return this.generiek;
                /*
                const baan1Dagen = this.jobDays[0];
                const baan2Dagen = this.jobDays[1];
                let comment;

                if (this.userProfile.baan1.isTeacher) {
                    comment = this.commentsEenBaanDocent[baan1Dagen-1];
                } else {
                    comment = this.commentsEenBaanDocent[baan2Dagen-1];
                }
                return comment;
                */
            }
        },
        methods: {
            _validCombination() {
                return this.jobDays[0] >= 1 && this.jobDays[1] >= 1;
            },
            getJobDescrption(job) {
                return job ? job.label : '';
            },
            selectType(jobIndex, nmbDays) {
                this.daysSubmitted = false;

                /* Make sure the update is reactive */
                const otherIndex = (jobIndex + 1) % 2;
                const maxWorkDays = 5;

                let otherJobDays = this.jobDays[otherIndex];

                if (otherJobDays + nmbDays > maxWorkDays) {
                    otherJobDays = maxWorkDays - nmbDays;
                    this.setDays(otherIndex, otherJobDays);
                }
                this.setDays(jobIndex, nmbDays);
            },

            setDays(jobIndex, nmbDays) {
                this.$set(this.jobDays, jobIndex, nmbDays);
                const key = `uren${jobIndex + 1}`;
                this.$emit('profileupdate', { key, value: nmbDays })
            },

            daysClass(i, nmbDays) {
                return {
                    'days-select__day--selected': this.jobDays[i] === nmbDays
                }
            },
            submitDays() {
                this.daysSubmitted = true;
                if (this._validCombination()) {
                    TweenLite.to(window, 1, {scrollTo: '.page-dagen-kiezen .result-anchor'});
                }
            }
        }

    }
</script>



// WEBPACK FOOTER //
// page-dagen-kiezen.vue?1f86c58b